const Footer = () => {
  return (
    <div className="footer mt-20 bg-transparent text-violet-50 text-center py-7">
      <p>&copy: {new Date().getFullYear()} Proxima. All rights reserve</p>
    </div>
  );
};

export default Footer;
